var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "grow", class: { notify: _vm.notifyClass } },
    [
      !_vm.drawer && _vm.$wf.isMdUp
        ? _c(
            "w-link",
            {
              staticClass: "toggle-drawer toggle-drawer-closed",
              on: {
                click: function ($event) {
                  _vm.drawer = true
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "angle-right" } })],
            1
          )
        : _vm._e(),
      !_vm.disabledDrawer
        ? _c(
            "w-drawer",
            {
              staticClass: "main-drawer",
              class: { toggle: _vm.toggleDrawer },
              attrs: { hover: _vm.$wf.isSmDown, "swipe-open": "" },
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [
              _vm.isAccountant
                ? _c("app-nav-item", {
                    staticClass: "first-item",
                    attrs: {
                      text: _vm.$ct("portal"),
                      icon: "icon-briefcase",
                      to: "/portal",
                    },
                  })
                : _vm._e(),
              _vm.showQuickStart
                ? _c("app-nav-item", {
                    class: { "first-item": !_vm.isAccountant },
                    attrs: {
                      text: _vm.$ct("start"),
                      icon: "icon-stopwatch-running",
                      to: "/start",
                    },
                  })
                : _vm._e(),
              _vm.visibleLinks.Dashboard
                ? _c("app-nav-item", {
                    class: {
                      "first-item": !_vm.showQuickStart && !_vm.isAccountant,
                    },
                    attrs: {
                      text: _vm.$ct("dashboard"),
                      icon: "icon-speed-fast",
                      to: "/home",
                    },
                  })
                : _vm._e(),
              _vm.showSettings && _vm.showSettingsLink
                ? _c("app-nav-item", {
                    attrs: {
                      text: _vm.$ct("settings"),
                      icon: "icon-gear3",
                      to: "/settings",
                    },
                  })
                : _vm._e(),
              _vm.showInbox && _vm.visibleLinks.Inbox
                ? _c("app-nav-item", {
                    attrs: {
                      permissions: _vm.permissions.PurchasePermissions,
                      text: _vm.$ct("inbox"),
                      icon: "icon-mailbox-full",
                      to: "/inbox",
                      "new-label":
                        _vm.dossierConfig.peppolRegistrationStatus == 0,
                    },
                  })
                : _vm._e(),
              _vm._l(_vm.visibleDrawerLinks.Top, function (link) {
                return _c("app-nav-item", {
                  key: link.uid,
                  attrs: {
                    icon: link.Icon,
                    text: link.Name,
                    to: "/custom-page/" + link.uid,
                  },
                })
              }),
              _vm.visibleLinks.getContactsVisible() ||
              _vm.visibleDrawerLinks.Contacts.length > 0
                ? [
                    _c("w-divider"),
                    _c(
                      "w-drawer-item-group",
                      { attrs: { value: "" } },
                      [
                        _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                          _vm._v(" " + _vm._s(_vm.$ct("contacts")) + " "),
                        ]),
                        _vm.visibleLinks.Custommers
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(1),
                                permissions: _vm.permissions.ClientPermissions,
                                text: _vm.$ct("customers"),
                                "new-to": "/contacts/customer/new",
                                to: "/contacts/customers",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.Suppliers
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(2),
                                permissions:
                                  _vm.permissions.SupplierPermissions,
                                text: _vm.$ct("suppliers"),
                                "new-to": "/contacts/supplier/new",
                                to: "/contacts/suppliers",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.Prospects
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(3),
                                permissions:
                                  _vm.permissions.ProspectPermissions,
                                text: _vm.$ct("prospects"),
                                "new-to": "/contacts/prospect/new",
                                to: "/contacts/prospects",
                              },
                            })
                          : _vm._e(),
                        _vm._l(
                          _vm.visibleDrawerLinks.Contacts,
                          function (link) {
                            return _c("app-nav-item", {
                              key: link.uid,
                              attrs: {
                                icon: link.Icon,
                                text: link.Name,
                                to: "/custom-page/" + link.uid,
                              },
                            })
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm.visibleLinks.getProductsVisible() ||
              _vm.visibleDrawerLinks.Products.length > 0
                ? [
                    _c("w-divider"),
                    _c(
                      "w-drawer-item-group",
                      { attrs: { value: "" } },
                      [
                        _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                          _vm._v(" " + _vm._s(_vm.$ct("products")) + " "),
                        ]),
                        _vm.visibleLinks.Products
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(4),
                                permissions: _vm.permissions.ProductPermissions,
                                text: _vm.$ct("products"),
                                "new-to": "/products/new",
                                to: "/products",
                              },
                            })
                          : _vm._e(),
                        _vm.hasPriceListModule && _vm.visibleLinks.PriceLists
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: "icon-clipboard-text",
                                permissions: _vm.permissions.ProductPermissions,
                                text: _vm.$ct("price-lists"),
                                "new-to": "/price-lists",
                                to: "/price-lists",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.Stock
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(5),
                                permissions: _vm.permissions.StockPermissions,
                                text: _vm.$ct("stock"),
                                "new-to": "/stock/new",
                                to: "/stock",
                              },
                            })
                          : _vm._e(),
                        _vm._l(
                          _vm.visibleDrawerLinks.Products,
                          function (link) {
                            return _c("app-nav-item", {
                              key: link.uid,
                              attrs: {
                                icon: link.Icon,
                                text: link.Name,
                                to: "/custom-page/" + link.uid,
                              },
                            })
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm.visibleLinks.getSalesVisible() ||
              _vm.visibleDrawerLinks.Sales.length > 0
                ? [
                    _c("w-divider"),
                    _c(
                      "w-drawer-item-group",
                      { attrs: { value: "" } },
                      [
                        _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                          _vm._v(" " + _vm._s(_vm.$ct("sales")) + " "),
                        ]),
                        _vm.visibleLinks.Sales
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(6),
                                permissions: _vm.permissions.SalePermissions,
                                text: _vm.$ct("invoices"),
                                "new-to": "/sales/new",
                                to: "/sales",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.FrequencyDocuments
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(10),
                                permissions:
                                  _vm.permissions.SubscriptionPermissions,
                                text: _vm.$ct("subscriptions"),
                                "new-to": "/subscriptions/new",
                                to: "/subscriptions",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.SaleRows
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(7),
                                permissions: _vm.permissions.SaleRowPermissions,
                                text: _vm.$ct("salesDetail"),
                                to: "/sales/detail",
                              },
                            })
                          : _vm._e(),
                        _vm._l(_vm.visibleDrawerLinks.Sales, function (link) {
                          return _c("app-nav-item", {
                            key: link.uid,
                            attrs: {
                              icon: link.Icon,
                              text: link.Name,
                              to: "/custom-page/" + link.uid,
                            },
                          })
                        }),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm.visibleLinks.getPurchasesVisible() ||
              _vm.visibleDrawerLinks.Buy.length > 0
                ? [
                    _c("w-divider"),
                    _c(
                      "w-drawer-item-group",
                      { attrs: { value: "" } },
                      [
                        _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                          _vm._v(" " + _vm._s(_vm.$ct("buy")) + " "),
                        ]),
                        _vm.visibleLinks.Purchases
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(9),
                                permissions:
                                  _vm.permissions.PurchasePermissions,
                                text: _vm.$ct("purchase"),
                                "new-to": "/purchase/new",
                                to: "/purchase",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.PurchaseDocuments
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(12),
                                permissions:
                                  _vm.permissions.PurchaseDocumentPermissions,
                                text: _vm.$ct("bestelbon-supplier"),
                                "new-to": "/purchase-documents/new",
                                to: "/purchase-documents",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.PurchaseDocumentRows
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(7),
                                permissions: _vm.permissions.SaleRowPermissions,
                                text: _vm.$ct("bestelbon-supplier-detail"),
                                to: "/purchase-documents/detail",
                              },
                            })
                          : _vm._e(),
                        _vm._l(_vm.visibleDrawerLinks.Buy, function (link) {
                          return _c("app-nav-item", {
                            key: link.uid,
                            attrs: {
                              icon: link.Icon,
                              text: link.Name,
                              to: "/custom-page/" + link.uid,
                            },
                          })
                        }),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm.visibleLinks.getFinancialVisible() ||
              _vm.visibleDrawerLinks.Financial.length > 0
                ? [
                    _c("w-divider"),
                    _c(
                      "w-drawer-item-group",
                      { attrs: { value: "" } },
                      [
                        _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                          _vm._v(" " + _vm._s(_vm.$ct("financial")) + " "),
                        ]),
                        _vm.visibleLinks.Bank
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: _vm.getBrowseIcon(8),
                                permissions: _vm.permissions.BankPermissions,
                                text: _vm.$ct("bank"),
                                "new-to": "/bank/new",
                                to: "/bank",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.Bookkeeping
                          ? _c("app-nav-item", {
                              attrs: {
                                icon: "icon-book",
                                permissions:
                                  _vm.permissions.BookKeepingPermissions,
                                text: _vm.$ct("bookkeeping"),
                                to: "/bookkeeping",
                              },
                            })
                          : _vm._e(),
                        _vm._l(
                          _vm.visibleDrawerLinks.Financial,
                          function (link) {
                            return _c("app-nav-item", {
                              key: link.uid,
                              attrs: {
                                icon: link.Icon,
                                text: link.Name,
                                to: "/custom-page/" + link.uid,
                              },
                            })
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm.visibleLinks.getToolsVisible() ||
              _vm.visibleDrawerLinks.Tools.length > 0
                ? [
                    _c("w-divider"),
                    _c(
                      "w-drawer-item-group",
                      { attrs: { value: "" } },
                      [
                        _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                          _vm._v(" " + _vm._s(_vm.$ct("tools")) + " "),
                        ]),
                        _vm.visibleLinks.Crm
                          ? _c("app-nav-item", {
                              attrs: {
                                text: _vm.$ct("crm"),
                                icon: "icon-head-bubble",
                                to: "/crm",
                              },
                            })
                          : _vm._e(),
                        _vm.hasProjectModule && _vm.visibleLinks.Projects
                          ? _c("app-nav-item", {
                              attrs: {
                                text: _vm.$ct("project"),
                                icon: "icon-hammer-wrench",
                                to: "/projects",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.Calendar
                          ? _c("app-nav-item", {
                              attrs: {
                                text: _vm.$ct("calendar"),
                                icon: "icon-calendar",
                                to: "/agenda",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.Tasks
                          ? _c("app-nav-item", {
                              attrs: {
                                text: _vm.$ct("tasks"),
                                icon: "icon-checklist2",
                                to: "/tasks",
                              },
                            })
                          : _vm._e(),
                        _vm.visibleLinks.Car
                          ? _c("app-nav-item", {
                              attrs: {
                                permissions: _vm.permissions.CarPermissions,
                                text: _vm.$ct("cars"),
                                icon: "icon-car",
                                "new-to": "/cars/new",
                                to: "/cars",
                              },
                            })
                          : _vm._e(),
                        _vm._l(_vm.visibleDrawerLinks.Tools, function (link) {
                          return _c("app-nav-item", {
                            key: link.uid,
                            attrs: {
                              icon: link.Icon,
                              text: link.Name,
                              to: "/custom-page/" + link.uid,
                            },
                          })
                        }),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _c("w-divider"),
              _vm._l(_vm.visibleDrawerLinks.Bottom, function (link) {
                return _c("app-nav-item", {
                  key: link.uid,
                  attrs: {
                    icon: link.Icon,
                    text: link.Name,
                    to: "/custom-page/" + link.uid,
                  },
                })
              }),
              _vm.showSettingsLink
                ? _c("app-nav-item", {
                    staticClass: "mt",
                    attrs: {
                      text: _vm.$ct("settings"),
                      icon: "icon-gear3",
                      to: "/settings",
                    },
                  })
                : _vm._e(),
              _vm.drawer && _vm.$wf.isMdUp
                ? _c(
                    "w-link",
                    {
                      staticClass: "toggle-drawer toggle-drawer-opened",
                      on: {
                        click: function ($event) {
                          _vm.drawer = false
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "angle-left" } })],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.showDemoExpiresMessage
        ? _c(
            "div",
            { staticClass: "demo-info" },
            [
              _vm.$wf.isMdUp
                ? _c("span", {
                    directives: [
                      {
                        name: "safe-html",
                        rawName: "v-safe-html",
                        value: _vm.dayBeforeMsg,
                        expression: "dayBeforeMsg",
                      },
                    ],
                  })
                : _vm._e(),
              _vm.$wf.isMdUp
                ? _c(
                    "w-link",
                    { staticClass: "mls mrs", attrs: { to: "/account" } },
                    [_c("b", [_vm._v(_vm._s(_vm.$ct("demo-activate")))])]
                  )
                : _vm._e(),
              _c("span", { staticClass: "mls" }, [
                _vm._v(_vm._s(_vm.$ct("demo-shedule-info"))),
              ]),
              _c(
                "w-link",
                {
                  staticClass: "mls",
                  on: {
                    click: function ($event) {
                      _vm.toggleDemoShedule = true
                    },
                  },
                },
                [_c("b", [_vm._v(_vm._s(_vm.$ct("demo-shedule")))])]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showServicePackExpiredMessages
        ? _c(
            "div",
            { staticClass: "demo-info" },
            [
              _vm._v(" " + _vm._s(_vm.$ct("service_expired-1")) + " "),
              _c("w-link", { attrs: { to: "/account/service-pack" } }, [
                _vm._v(_vm._s(_vm.$ct("service_expired-extend"))),
              ]),
              _vm._v(" " + _vm._s(_vm.$ct("service_expired-2")) + " "),
              _c("w-fa", {
                staticClass: "mls",
                attrs: { icon: "times" },
                on: {
                  click: function ($event) {
                    _vm.forceCloseSaleBar = true
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("app-renew-info", {
        on: {
          show: function ($event) {
            _vm.renewShow = $event
          },
        },
      }),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.toggleDemoShedule,
            callback: function ($$v) {
              _vm.toggleDemoShedule = $$v
            },
            expression: "toggleDemoShedule",
          },
        },
        [
          _c("app-demo-shedule", {
            on: {
              cancel: function ($event) {
                _vm.toggleDemoShedule = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { mode: "out-in", name: "fast-fade" } },
        [_c("router-view")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }